import { Descriptions, Dropdown, Input, Spin, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import svg38 from "../../../../assets/svg/svg38.svg";
import MaterialIcon from "material-icons-react";
import {
  capitalize,
  cashConverter,
  dateForHumans,
  timeAmPm,
} from "../../../../utils";
import FilterModal from "./FilterModal";
import svg67 from "../../../../assets/svg/svg67.svg";
import svg32 from "../../../../assets/svg/svg32.svg";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import ConfirmSubmitModal from "../../../../components/ConfirmSubmitModal";
import { fetchPaymentDetails } from "../../../../features/fetch/fetchSlice";
import DeleteModal from "../../../../components/DeleteModal";
import BreadCrumb from "../../../../layout/BreadCrumb";
import OtpModal from "./modal/OtpModal";

export default function GroupPaymentDetailsTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { paymentDetails, dropLoading, paymentDetailsCount } = useSelector(
    (state) => state.fetch
  );
  const { directHeaderObj } = useSelector((state) => state.obj);
  const { saving } = useSelector((state) => state.save);

  const [searchText, setSearchText] = useState("");

  const [open, setopen] = useState(false);

  const [prodd, setProdd] = useState("");
  const [prodd1, setProdd1] = useState("");

  function handleCancel() {
    setopen(false);
  }

  const [openSingle, setopenSingle] = useState(false);
  function handleCancelSingle() {
    setopenSingle(false);
  }
  async function handleOpenSingle() {
    await setopenSingle(true);
  }
  const handleEditSingle = () => {
    setopenSingle(true);
  };

  const handleDelete = async () => {};

  const [openOtp, setOpenOtp] = useState(false);
  const handleOpenOtp = async (item) => {
    setProdd1(item);
    const res = await dispatch(
      save({
        url: `api/v1/payments/initiate-single-payment/${item?.blkUid}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res.payload?.messages?.message);
      await setProdd(res?.payload?.data?.result);
      await setOpenOtp(true);
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };
  const handleCancelOtp = () => {
    setOpenOtp(false);
  };

  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModalFilter = () => {
    setIsModalOpen(true);
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await dispatch(
      fetchPaymentDetails({
        url: "/api/v1/payments/fetch-payment-details",
      })
    );
    await setFilters([]);
  };

  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const [isModalOpenSubmit, setIsModalOpenSubmit] = useState(false);

  const handleConfirmation = async (item) => {
    await setProdd(item);
    await setIsModalOpenSubmit(true);
  };

  const handleCancelConfirmation = async () => {
    await setIsModalOpenSubmit(false);
  };

  const handleSubmit = async () => {
    const res = await dispatch(
      save({
        blkUid: prodd?.blkUid,
        url: `api/v1/payments/verify-single-payment`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res.payload?.messages?.message);
      await setIsModalOpenSubmit(false);
      await setProdd();
      await fetchPaymentDetailsData();
    } else {
      toast.error(res.payload?.messages?.message);
    }
  };

  // {
  //   title: "Retry Payment",
  //   render: (item) => {
  //     if (item?.payStatus === "PROCESSED" || item?.payStatus == null) {
  //       return null;
  //     }
  //     return (
  //       <button disabled={saving} onClick={() => handleConfirmation(item)}>
  //         {saving && !openOtp ? (
  //           <Spin className="blu_spin" />
  //         ) : (
  //           <img src={svg32} alt="svg32" />
  //         )}
  //       </button>
  //     );
  //   },
  // },
  const columns = [
    {
      title: "Benefitiary Account",
      dataIndex: "payBeneficiaryAccount",
      key: "payBeneficiaryAccount",
      sorter: (a, b) =>
        a.payBeneficiaryAccount.localeCompare(b.payBeneficiaryAccount),
    },
    {
      title: "Beneficiary Bank",
      dataIndex: "bnkName",
      key: "bnkName",
      sorter: (a, b) =>
        a.bnkName.localeCompare(b.bnkName),
    },
    {
      title: "Beneficiary Details",
      dataIndex: "payBeneficiaryDetails",
      key: "payBeneficiaryDetails",
      sorter: (a, b) =>
        a.payBeneficiaryDetails.localeCompare(b.payBeneficiaryDetails),
    },
    {
      title: "Receiver Mobile",
      dataIndex: "payReceiverMobileNo",
      key: "payReceiverMobileNo",
      sorter: (a, b) =>
        a.payReceiverMobileNo.localeCompare(b.payReceiverMobileNo),
    },
    {
      title: "National ID Number",
      dataIndex: "payIdNumber",
      sorter: (a, b) => a.payIdNumber.localeCompare(b.payIdNumber),
    },
    {
      title: "Receiver Name",
      dataIndex: "payReceiverName",
      sorter: (a, b) => a.payReceiverName.localeCompare(b.payReceiverName),
    },
    {
      title: "Payment Date",
      dataIndex: "payCreatedDate",
      sorter: (a, b) => a.payCreatedDate.localeCompare(b.payCreatedDate),
    },
    {
      title: "Payment Reason",
      onCell: () => ({
        style: {
          maxWidth: 300,
          whiteSpace: "normal",
          wordBreak: "break-word",
        },
      }),
      dataIndex: "payPaymentReason",
      sorter: (a, b) => a.payPaymentReason.localeCompare(b.payPaymentReason),
    },
    {
      title: "Payment Type",
      dataIndex: "payPaymentType",
      sorter: (a, b) => a.payPaymentType.localeCompare(b.payPaymentType),
    },
    {
      title: "Status",
           dataIndex: "payStatus",
      render: (item) => {
        return (
          <div
            className={`${
              item === "PENDING" || item == null
                ? "bg-[#FFA500]"
                : item === "FAILED"
                ? "bg-[#FF1A1A]"
                : item === "PROCESSED"
                ? "bg-darkGreen"
                : item === "PROCESSING"
                ? "bg-[#FF6F00]"
                : "bg-darkGreen"
            } 
               text-[#FFf]  inline-block rounded-[5px] px-2 py-1 w-auto`}
          >
            {item}
          </div>
        );
      },
    },
      {
      title: "Remote Desc",
        onCell: () => ({
        style: {
          maxWidth: 400,
          whiteSpace: "normal",
          wordBreak: "break-word",
        },
      }),
      dataIndex: "payRemoteStatusDesc",
      render:(item)=>{
        return(
          <div>{item}</div>
        )
      }, 
    },
    {
      title: "Thread Time",
      dataIndex: "payCreatedTime",
      render: (item) => {
        return <div>{timeAmPm(item)}</div>;
      },
      sorter: (a, b) => a.payCreatedTime - b.payCreatedTime,
    },
  ].filter((column) => {
    const paymentMode = directHeaderObj?.pyPaymentMode;

    if (paymentMode === "MOBILE_MONEY" || paymentMode === "GROUP") {
      const bankColumns = [
        "payBeneficiaryAccount",
        "payBeneficiaryBank",
        "payBeneficiaryDetails",
        "payIdNumber",
      ];
      if (bankColumns.includes(column.key)) {
        return false;
      }
    }

    if (paymentMode === "BANK") {
      if (column.key === "payReceiverMobileNo") {
        return false;
      }
    }

    return true;
  });
  const items = [
    {
      key: "2",
      label: "Created Date",
      children: <div>{dateForHumans(directHeaderObj?.pyCreatedDate)}</div>,
    },
    {
      key: "3",
      label: "Created Time",
      children: <div>{timeAmPm(directHeaderObj?.pyCreatedTime)}</div>,
    },
   
    {
      key: "5",
      label: "Total Amount",
      children: <div>{cashConverter(directHeaderObj?.pyTotalAmount)}</div>,
    },
    {
      key: "6",
      label: "Initiator",
      children: directHeaderObj?.usrFirstName,
    },
    {
      key: "7",
      label: "Category",
      children: directHeaderObj?.pcName,
    },
    {
      key: "8",
      label: "Sub-Category",
      children: directHeaderObj?.pscName,
    },
    {
      key: "9",
      label: "Status",
      children: directHeaderObj?.pyStatus,
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchPaymentDetailsData(page, size) {
    dispatch(
      fetchPaymentDetails({
        url: "api/v1/payments/fetch-payment-details",
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        pyId: directHeaderObj?.pyId,
      })
    );
  }

  const handleBack = async () => {
    await navigate("/group-payment");
  };
  const breadList = [
    {
      title: (
        <div className="flex items-center gap-[.25rem] cursor-pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clipPath="url(#clip0_627_13942)">
              <path
                d="M13.7899 6.89067L7.75241 0.856289L7.34772 0.451602C7.25551 0.360003 7.13082 0.308594 7.00085 0.308594C6.87087 0.308594 6.74618 0.360003 6.65397 0.451602L0.211783 6.89067C0.117301 6.98478 0.0426296 7.09687 -0.00782254 7.22031C-0.0582747 7.34376 -0.0834854 7.47607 -0.0819665 7.60942C-0.0757165 8.15942 0.382096 8.59848 0.932096 8.59848H1.59616V13.6875H12.4055V8.59848H13.0837C13.3508 8.59848 13.6024 8.49379 13.7915 8.30473C13.8846 8.21193 13.9583 8.10159 14.0085 7.98009C14.0586 7.8586 14.0842 7.72836 14.0837 7.59692C14.0837 7.33129 13.979 7.07973 13.7899 6.89067ZM7.87585 12.5625H6.12585V9.37504H7.87585V12.5625ZM11.2805 7.47348V12.5625H8.87585V9.00004C8.87585 8.65473 8.59616 8.37504 8.25085 8.37504H5.75085C5.40553 8.37504 5.12585 8.65473 5.12585 9.00004V12.5625H2.72116V7.47348H1.22116L7.00241 1.69691L7.36335 2.05785L12.7821 7.47348H11.2805Z"
                fill="black"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <clipPath id="clip0_627_13942">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span onClick={handleBack}>Group Payments List</span>
        </div>
      ),
    },
    {
      title: capitalize("Group Payments Details"),
    },
  ];

  useEffect(() => {
    fetchPaymentDetailsData();
  }, []);

  return (
    <div className="w-full  overflow-y-scroll h-full">
      <div className="justify-between items-center white_card">
        <BreadCrumb
          breadList={breadList}
          header={"Group Payments Details"}
          info={"Manage group payment details within your payment header"}
        />
      </div>

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full min-h-[100vh]">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="mt-[1.25rem]">
            <Descriptions
               column={{
              xs: 1,
              sm: 2,
              md: 2,
              lg: 3,
              xl: 3,
              xxl: 3,
            }}
              colon={false}
              title="Payment Header Information"
              items={items}
            />
          </div>
          <div className="flex justify-between items-center">
            <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
              Payment Details
            </h3>
          </div>
          <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
            <div className="flex items-center">
              <span>
                {" "}
                <button
                  onClick={showModalFilter}
                  type="button"
                  className={`bg-transparent flex items-center gap-x-'1' ${
                    Object?.keys(formData)?.length > 0
                      ? "!text-[#5688E5]"
                      : "inherit"
                  }`}
                >
                  <MaterialIcon color="#141414" icon="filter_list" />
                  Filters
                </button>
              </span>
              {Object?.keys(formData)?.length > 0 && (
                <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                  :{Object?.keys(formData)?.length}
                  <img src={svg38} alt="svg38" onClick={handleClearFilters} />
                </span>
              )}
            </div>
          </div>

          <div
            className="cursor-pointer flex items-center justify-center mt-[5px]"
            onClick={() => fetchPaymentDetailsData(0, 10)}
          >
            <img src={svg67} alt="svg67" />
          </div>

          <div className="dash-inner-page mt-[24px] ">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{ x: "max-content" }}
                rowKey={(record) => record?.pdId}
                columns={columns}
                dataSource={paymentDetails}
                loading={dropLoading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: paymentDetailsCount,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchPaymentDetailsData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <FilterModal
        isModalOpen={open}
        handleCancel={handleCancel}
        formData={formData}
        setFormData={setFormData}
        filters={filters}
        setFilters={setFilters}
      />

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={dropLoading}
        content={`Are you sure you want to delete ${prodd?.phNo}?`}
        title={`Delete ${prodd?.phNo}`}
      />

      <ConfirmSubmitModal
        isModalOpen={isModalOpenSubmit}
        setIsModalOpen={setIsModalOpenSubmit}
        handleSubmit={handleSubmit}
        handleCancel={handleCancelConfirmation}
        loading={saving}
        content={`Are you sure you want to retry payment for ${
          prodd?.payReceiverMobileNo ?? prodd?.payBeneficiaryAccount
        } `}
      />

      <OtpModal
        handleFetchData={fetchPaymentDetailsData}
        open={openOtp}
        handleCancel={handleCancelOtp}
        prodd={prodd}
        prodd1={prodd1}
      />
    </div>
  );
}
